import { render, staticRenderFns } from "./TableScalesByWeight.vue?vue&type=template&id=8ce56f5a&scoped=true"
import script from "./TableScalesByWeight.vue?vue&type=script&lang=js"
export * from "./TableScalesByWeight.vue?vue&type=script&lang=js"
import style0 from "./TableScalesByWeight.vue?vue&type=style&index=0&id=8ce56f5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce56f5a",
  null
  
)

export default component.exports